import { render, staticRenderFns } from "./AreaDictionary.vue?vue&type=template&id=c45fce70&scoped=true"
import script from "./AreaDictionary.vue?vue&type=script&lang=js"
export * from "./AreaDictionary.vue?vue&type=script&lang=js"
import style1 from "./AreaDictionary.vue?vue&type=style&index=1&id=c45fce70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45fce70",
  null
  
)

export default component.exports